import { atom, useAtomValue } from 'jotai'
import type { Atom } from 'jotai'
import { planName } from '~/lib/plan/name'
import type { ReserveInputPlan, ReserveInputReserveInfo } from './stateMachine/state'
import { plan$, reserveInfo$ } from './stateMachine/state'

type DisplayPlanContents =
  | ({
      type: 'course'
      price: number
      label: string
      props: {
        title: string
        annotation: string
      }
    } & ReserveInputPlan)
  | ({
      type: 'seatOnly'
      label: string
      props: {
        title: string
      }
    } & ReserveInputPlan)

export const displayPlanContents$: Atom<DisplayPlanContents | undefined> = atom((get) => {
  return createDisplayPlanContents({
    plan: get(plan$),
    reserveInfo: get(reserveInfo$),
  })
})
displayPlanContents$.debugLabel = 'displayPlanContents$'

function createDisplayPlanContents(data: {
  plan?: ReserveInputPlan
  reserveInfo?: ReserveInputReserveInfo
}): DisplayPlanContents | undefined {
  if (data.plan === undefined || data.reserveInfo === undefined) {
    return undefined
  }
  return data.plan.isSeatOnly
    ? {
        ...data.plan,
        type: 'seatOnly',
        props: {
          title: 'ご予約内容',
        },
        label: planName(data.plan),
      }
    : {
        ...data.plan,
        type: 'course',
        props: {
          title: 'ご予約内容',
          annotation: 'お一人様　消費税・サービス料込',
        },
        label: planName(data.plan),
        price: data.reserveInfo.inventory.price,
      }
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('createDisplayPlanContents', () => {
    let plan = {
      course: { name: 'コース名' },
      additionalContents: '追加内容',
      restrictions: '制約',
      isSeatOnly: false,
    } as ReserveInputPlan
    const reserveInfo = {
      inventory: { price: 1000 },
    } as ReserveInputReserveInfo
    expect(createDisplayPlanContents({ plan, reserveInfo })).toEqual({
      course: { name: 'コース名' },
      additionalContents: '追加内容',
      restrictions: '制約',
      isSeatOnly: false,
      type: 'course',
      props: {
        title: 'ご予約内容',
        annotation: 'お一人様　消費税・サービス料込',
      },
      label: 'コース名＋追加内容（制約）',
      price: 1000,
    })
    plan.isSeatOnly = true
    expect(createDisplayPlanContents({ plan, reserveInfo })).toEqual({
      course: { name: 'コース名' },
      additionalContents: '追加内容',
      restrictions: '制約',
      isSeatOnly: true,
      type: 'seatOnly',
      props: {
        title: 'ご予約内容',
      },
      label: 'コース名＋追加内容（制約）',
    })
  })
}

export function useDisplayPlanContents() {
  return useAtomValue(displayPlanContents$)
}
